(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) {
          return;
        }

        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) {
        return;
      }

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) {
        return;
      }

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) {
        return;
      }

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-edwige"] && !Shopify.designMode) return;
  try {
    
/* EL Hero Motion — sans GSAP, sans dépendance externe.
   Configuré par les data-* définis dans hero-edwige.liquid. */
if (!customElements.get('el-hero-motion')) {
  customElements.define('el-hero-motion', class extends HTMLElement {
    connectedCallback() {
      this.run = (this.run || 0) + 1;
      const run = this.run;
      this.frame = requestAnimationFrame(() => {
        if (this.isConnected && this.run === run) this.init();
      });
    }

    number(value, fallback, min, max) {
      const n = Number(value);
      return Number.isFinite(n) && value !== undefined && value !== null && value !== ''
        ? Math.max(min, Math.min(max, n)) : fallback;
    }

    deviceName() {
      const width = window.innerWidth;
      return width < 750 ? 'mobile' : width < 1180 ? 'tablet' : 'desktop';
    }

    readProfile() {
      const device = this.deviceName();
      const get = suffix => this.dataset[device + suffix] === 'true';
      const enabled = get('Enable') && this.dataset.entry === 'true' && !this.reduced.matches;
      const speed = this.number(this.dataset[device + 'Speed'], 80, 50, 150) / 100;
      return {
        device, enabled, speed,
        title: enabled && get('Title'),
        text: enabled && get('Text'),
        buttons: enabled && get('Buttons'),
        models: enabled && get('Models'),
        decor: enabled && get('Decor'),
        scroll: !this.reduced.matches && get('Enable') && get('Scroll') && this.dataset.scroll === 'true',
        letterByLetter: this.dataset.titleLetters === 'true'
      };
    }

    init() {
      this.root = this.closest('.el-hero');
      if (!this.root) return;
      this.abort = new AbortController();
      this.animations = new Set();
      this.seen = new WeakSet();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.pointer = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
      this.layers = [
        [this.root.querySelector('.el-hero__image--1'), .65, .65],
        [this.root.querySelector('.el-hero__image--2'), 1, 1],
        [this.root.querySelector('.el-hero__image--3'), .8, .8],
        [this.root.querySelector('.el-hero__africa'), -.35, -.6],
        [this.root.querySelector('.el-hero__cream-shape'), 0, .35],
        [this.root.querySelector('.el-hero__mobile-visual'), 0, .85]
      ].filter(([node]) => node);
      this.strength = this.number(this.dataset.strength, 6, 0, 12);
      this.scrollStrength = this.number(this.dataset.scrollStrength, 24, 0, 40);
      this.buttonGap = this.number(this.dataset.buttonGap, 220, 0, 500);
      this.modelGap = this.number(this.dataset.modelGap, 550, 0, 1000);
      this.modelOpacity = this.number(this.dataset.modelOpacity, 0, 0, 100) / 100;
      this.pendingImages = new Set();
      this.letterGap = this.number(this.dataset.letterGap, 12, 0, 35);
      this.entryDistance = this.number(this.dataset.entryDistance, 6, 0, 20);
      this.target = [0, 0];
      this.profile = this.readProfile();
      const signal = this.abort.signal;

      this.sync = () => {
        const old = this.profile;
        this.profile = this.readProfile();
        this.depth = !this.reduced.matches && this.pointer.matches &&
          this.dataset.depth === 'true' && this.strength > 0 &&
          this.dataset[this.profile.device + 'Enable'] === 'true';
        this.scrollEnabled = this.profile.scroll && this.scrollStrength > 0;
        this.root.classList.toggle('el-motion-depth', this.depth);
        this.root.classList.toggle('el-motion-buttons', this.profile.buttons);
        if (!this.depth) this.target = [0, 0];
        if (this.reduced.matches) {
          this.animations.forEach(animation => animation.cancel());
          this.animations.clear();
        }
        if (old && (old.device !== this.profile.device || old.enabled !== this.profile.enabled)) {
          this.setupEntry();
        }
        this.queueRender();
      };

      this.root.addEventListener('pointermove', event => {
        if (!this.depth || event.pointerType !== 'mouse') return;
        const rect = this.root.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        this.target = [
          Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width - .5) * 2)),
          Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height - .5) * 2))
        ];
        this.queueRender();
      }, {passive: true, signal});
      this.root.addEventListener('pointerleave', () => this.reset(), {signal});
      this.root.addEventListener('pointercancel', () => this.reset(), {signal});
      window.addEventListener('blur', () => this.reset(), {signal});
      window.addEventListener('scroll', () => {
        this.target = [0, 0];
        this.queueRender();
      }, {passive: true, signal});
      window.addEventListener('resize', () => this.sync(), {passive: true, signal});
      this.root.addEventListener('load', () => this.queueRender(), {capture: true, signal});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.reset();
      }, {signal});
      this.root.addEventListener('focusin', () => {
        this.animations.forEach(animation => animation.finish());
        this.releasePendingImages();
        this.entryObserver?.disconnect();
        this.reset();
      }, {signal});
      this.reduced.addEventListener('change', this.sync, {signal});
      this.pointer.addEventListener('change', this.sync, {signal});
      this.sync();
      this.setupEntry();
    }

    setupEntry() {
      this.entryObserver?.disconnect();
      this.entryObserver = null;
      // Rendre les visuels en attente si l'animation est desactivee ou si l'appareil change.
      this.releasePendingImages();
      if (!this.profile.enabled || !('IntersectionObserver' in window) ||
          !Element.prototype.animate) return;

      const p = this.profile;
      const entries = [
        [p.title, '.el-hero__heading', 0, 'text'],
        [p.text, '.el-hero__eyebrow', 200, 'text'],
        [p.text, '.el-hero__text', 380, 'text'],
        [p.buttons, '.el-hero__button--primary', 620, 'button'],
        [p.buttons, '.el-hero__button--secondary', 620 + this.buttonGap, 'button'],
        [p.models, '.el-hero__image--2 img', 180, 'image'],
        [p.models, '.el-hero__image--1 img', 180 + this.modelGap, 'image'],
        [p.models, '.el-hero__image--3 img', 180 + this.modelGap * 2, 'image'],
        [p.models, '.el-hero__mobile-visual img', 180, 'image'],
        [p.decor, '.el-hero__cream-shape', 0, 'shape'],
        [p.decor, '.el-hero__africa img', 230, 'decor']
      ];
      this.entryOptions = new Map();
      this.entryObserver = new IntersectionObserver(records => {
        records.forEach(record => {
          if (!record.isIntersecting || this.seen.has(record.target)) return;
          const options = this.entryOptions.get(record.target);
          if (!options) return;
          this.seen.add(record.target);
          this.entryObserver?.unobserve(record.target);
          this.enter(record.target, ...options);
        });
      }, {threshold: 0, rootMargin: '0px 0px -12px 0px'});
      entries.forEach(([enabled, selector, delay, kind]) => {
        if (!enabled) return;
        const node = this.root.querySelector(selector);
        if (node && !this.seen.has(node)) {
          // Masque des le debut les images a animer (sans masquer tout le Hero).
          // Aucune modification CSS permanente : sans JS, les images restent visibles.
          if (kind === 'image') {
            node.style.opacity = '0';
            this.pendingImages.add(node);
          }
          this.entryOptions.set(node, [delay, kind, p.speed]);
          this.entryObserver.observe(node);
        }
      });
    }

    releasePendingImages() {
      this.pendingImages?.forEach(node => node.style.removeProperty('opacity'));
      this.pendingImages?.clear();
    }

    async enter(node, delay, kind, speed) {
      const run = this.run;
      const device = this.profile.device;
      if (node.tagName === 'IMG' && typeof node.decode === 'function') {
        try { await node.decode(); } catch (_) { /* Continuer même si le décodage échoue. */ }
      }
      if (!this.isConnected || this.run !== run || this.reduced.matches ||
          !this.profile.enabled || this.profile.device !== device) {
        node.style.removeProperty('opacity');
        this.pendingImages?.delete(node);
        return;
      }
      if (kind === 'text' && node.classList.contains('el-hero__heading') &&
          this.profile.letterByLetter) {
        this.enterTitle(node, speed);
        return;
      }
      const image = kind === 'image' || kind === 'decor';
      const shape = kind === 'shape';
      const duration = (image ? 1150 : shape ? 850 : kind === 'button' ? 700 : 800) * speed;
      const distance = shape ? 8 : image ? Math.min(8, this.entryDistance) : this.entryDistance;
      const frames = shape
        ? [{transform: 'translateY(8px)'}, {transform: 'translateY(0)'}]
        : [{opacity: kind === 'image' ? this.modelOpacity : image ? .30 : .58,
            transform: `translateY(${distance}px)`},
           {opacity: 1, transform: 'translateY(0)'}];
      const animation = node.animate(frames, {
        duration,
        // L'ecart en millisecondes est independant de la vitesse (duree).
        delay,
        easing: image ? 'cubic-bezier(.42,0,.58,1)' : 'cubic-bezier(.22,1,.36,1)',
        fill: 'backwards'
      });
      // L'animation prend maintenant le relais du masquage temporaire.
      if (this.pendingImages?.has(node)) {
        node.style.removeProperty('opacity');
        this.pendingImages.delete(node);
      }
      this.track(animation);
    }

    track(animation) {
      this.animations.add(animation);
      animation.finished.then(() => {
        animation.cancel();
        this.animations.delete(animation);
      }, () => this.animations.delete(animation));
    }

    enterTitle(node, speed) {
      const text = node.textContent;
      if (!text.trim()) return;
      this.titleNode = node;
      this.titleOriginal = Array.from(node.childNodes).map(child => child.cloneNode(true));
      this.titleOriginalLabel = node.getAttribute('aria-label');
      const visual = document.createElement('span');
      visual.setAttribute('aria-hidden', 'true');
      const letters = [];
      const segmenter = typeof Intl.Segmenter === 'function'
        ? new Intl.Segmenter('fr', {granularity: 'grapheme'}) : null;
      const useWords = text.trim().length > 100;
      text.split(/(\s+)/).filter(Boolean).forEach(token => {
        if (/^\s+$/.test(token)) {
          visual.append(document.createTextNode(token));
          return;
        }
        const word = document.createElement('span');
        word.className = 'el-hero__motion-word';
        if (useWords) {
          word.textContent = token;
          letters.push(word);
        } else {
          const chars = segmenter
            ? Array.from(segmenter.segment(token), part => part.segment)
            : Array.from(token);
          chars.forEach(char => {
            const letter = document.createElement('span');
            letter.className = 'el-hero__motion-letter';
            letter.textContent = char;
            word.append(letter);
            letters.push(letter);
          });
        }
        visual.append(word);
      });
      node.setAttribute('aria-label', text.trim());
      node.replaceChildren(visual);
      const stagger = this.letterGap;
      letters.forEach((letter, index) => {
        this.track(letter.animate([
          {opacity: .45, transform: 'translateY(.06em)'},
          {opacity: 1, transform: 'translateY(0)'}
        ], {
          duration: 650 * speed,
          delay: index * stagger,
          easing: 'cubic-bezier(.22,1,.36,1)',
          fill: 'backwards'
        }));
      });
    }

    restoreTitle() {
      if (!this.titleNode || !this.titleOriginal) return;
      this.titleNode.replaceChildren(...this.titleOriginal);
      if (this.titleOriginalLabel === null) this.titleNode.removeAttribute('aria-label');
      else this.titleNode.setAttribute('aria-label', this.titleOriginalLabel);
      this.titleNode = null;
      this.titleOriginal = null;
    }

    queueRender() {
      if (this.moveFrame || !this.isConnected) return;
      if (!this.depth && !this.scrollEnabled) {
        this.layers?.forEach(([node]) => node.style.removeProperty('translate'));
        return;
      }
      this.moveFrame = requestAnimationFrame(() => {
        this.moveFrame = 0;
        if (!this.isConnected || document.hidden) return;
        const rect = this.root.getBoundingClientRect();
        if (!rect.height || rect.bottom <= 0 || rect.top >= innerHeight) return;
        const progress = this.scrollEnabled
          ? Math.max(0, Math.min(1, -rect.top / rect.height)) : 0;
        const [x, y] = this.depth ? this.target : [0, 0];
        this.layers.forEach(([node, pointerWeight, scrollWeight]) => {
          const dx = x * this.strength * pointerWeight;
          const dy = y * this.strength * pointerWeight * .6
            + progress * this.scrollStrength * scrollWeight;
          node.style.translate = `${dx.toFixed(2)}px ${dy.toFixed(2)}px`;
        });
      });
    }

    reset() {
      cancelAnimationFrame(this.moveFrame);
      this.moveFrame = 0;
      this.target = [0, 0];
      if (this.isConnected) this.queueRender();
      else this.layers?.forEach(([node]) => node.style.removeProperty('translate'));
    }

    disconnectedCallback() {
      this.run = (this.run || 0) + 1;
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.entryObserver?.disconnect();
      this.releasePendingImages();
      this.animations?.forEach(animation => animation.cancel());
      this.reset();
      this.restoreTitle();
      this.root?.classList.remove('el-motion-depth', 'el-motion-buttons');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
